import React, { useState, useEffect } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "./ui/select";
import { useToast } from "../hooks/use-toast";
import { CALL_TIMES } from "../mock";
import { submitInterest } from "../api";

const empty = { name: "", phone: "", budget: "", callTime: "", unitNumber: "" };

const InterestForm = ({ open, onOpenChange, unitNumber = "" }) => {
  const [form, setForm] = useState(empty);
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  useEffect(() => {
    if (open) setForm({ ...empty, unitNumber: unitNumber || "" });
  }, [open, unitNumber]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e?.target ? e.target.value : e }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitInterest(form);
      toast({ title: "تم استلام اهتمامك ✓", description: "سيتواصل معك فريقنا قريبًا." });
      onOpenChange(false);
    } catch (err) {
      toast({ title: "تعذّر الإرسال", description: "حاول مرة أخرى.", variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" dir="rtl">
        <DialogHeader className="text-right">
          <DialogTitle className="font-display text-2xl text-[#241C15]">سجّل اهتمامك</DialogTitle>
          <DialogDescription className="text-stone-500">
            كل الحقول اختيارية — اترك ما يناسبك وسنتواصل معك.
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4 mt-2">
          {form.unitNumber && (
            <div className="bg-[#F3ECE0] rounded-xl px-4 py-3 flex items-center justify-between">
              <span className="text-sm text-stone-500">رقم الوحدة</span>
              <span className="font-800 text-[#241C15]">{form.unitNumber}</span>
            </div>
          )}

          <div>
            <Label className="text-stone-600 mb-1.5 block">الاسم</Label>
            <Input value={form.name} onChange={set("name")} placeholder="اسمك" />
          </div>

          <div>
            <Label className="text-stone-600 mb-1.5 block">رقم الجوال</Label>
            <Input value={form.phone} onChange={set("phone")} placeholder="05xxxxxxxx" inputMode="tel" />
          </div>

          <div>
            <Label className="text-stone-600 mb-1.5 block">الميزانية (ريال)</Label>
            <Input value={form.budget} onChange={set("budget")} placeholder="مثال: 3,000,000" inputMode="numeric" />
          </div>

          <div>
            <Label className="text-stone-600 mb-1.5 block">وقت الاتصال المناسب</Label>
            <Select value={form.callTime} onValueChange={set("callTime")}>
              <SelectTrigger><SelectValue placeholder="اختر الوقت" /></SelectTrigger>
              <SelectContent>
                {CALL_TIMES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-xl bg-[#BF9A5A] hover:bg-[#a9853f] text-white font-700 transition-colors disabled:opacity-60"
          >
            {loading ? "جارٍ الإرسال..." : "إرسال"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default InterestForm;
